module.exports = __webpack_public_path__ + "img/partthree_pic.56c0e757.png";